import React from 'react';
export function Footer() {
  return <footer className="bg-dark-card border-t border-dark-border pt-16 pb-8 px-4 text-center" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <div className="mb-8" data-id="element-152">
          <div className="inline-flex items-center space-x-2 text-2xl font-black mb-4" data-id="element-153">
            <span data-id="element-154">PROTOCOLO MENTE INDOMABLE™</span>
          </div>
          <p className="text-gray-400 max-w-md mx-auto" data-id="element-155">
            El sistema de entrenamiento cognitivo N°1 para hombres de 50+ en
            Argentina.
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-156">
            Porque tener más de 50 años no significa tener menos mente.
            Significa tener más razones para cuidarla.
          </p>
        </div>

        <div className="border-t border-dark-border/50 pt-8 text-xs text-gray-600" data-id="element-157">
          <p className="mb-4" data-id="element-158">
            © Protocolo Mente Indomable™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}